export interface SearchDocumentModel {
  fid: string;
  geometry: string;
  displayValues: string[];
}
